// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Components
import { SvgContainer } from 'common/styles/oc-styled-components';

// Component
const DentistChairPersonSvg = ({ color, height, margin, width }) => (
  <SvgContainer color={color} height={height} margin={margin} width={width}>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="36"
      height="36"
      fill={color}
      viewBox="0 0 36 36"
      role="presentation"
    >
      <g fillRule="evenodd" transform="translate(-.926 -.406)">
        <path d="M32.725 24.8c-.346 0-.692-.098-1.038-.246l-7.166-3.51c-.098-.048-.148-.048-.247-.048H19.48c-.495 0-.99-.15-1.385-.445l-5.387-3.953c-.988-.74-1.334-2.076-.692-3.163a2.38 2.38 0 013.41-.692l4.696 3.46c.1.05.198.098.346.098h4.497c.346 0 .692.1 1.038.247l7.76 3.806c1.137.593 1.63 1.977 1.087 3.114-.445.84-1.285 1.334-2.125 1.334z" />
        <circle cx="8.853" cy="10.32" r="2.57" />
        <path d="M35.295 29.348l-9.737-4.794a1.35 1.35 0 00-.642-.148h-6.13a.71.71 0 01-.345-.1L3.22 13.04a1.399 1.399 0 00-2.028.346c-.444.643-.197 1.483.396 1.928l15.667 11.614c.247.198.544.297.84.297h.445a.39.39 0 01.396.395v5.78a.444.444 0 01-.445.446h-.69a.444.444 0 00-.446.445v.742c0 .247.198.445.445.445h6.968a.443.443 0 00.444-.445v-.74a.443.443 0 00-.444-.446h-.692a.443.443 0 01-.445-.445V27.67c0-.247.2-.396.396-.396h.346c.05 0 .15 0 .198.05l9.34 4.596c.2.1.397.15.644.15.494 0 1.038-.298 1.285-.792.443-.742.147-1.582-.545-1.928zM25.51.93h-5.487c-.297 0-.593.148-.74.395l-1.09 1.483c-.048.098-.147.098-.246.098-.94-.296-1.977 0-2.62.79-.098.1-.05.248.05.347l3.707 2.52c.1.1.247.05.346-.05a2.43 2.43 0 00-.1-2.52c-.048-.098-.048-.197 0-.246l.89-1.236c.05-.048.1-.098.198-.098h4.4c.147 0 .246.1.246.247v10.625c0 .396.297.692.692.692a.675.675 0 00.692-.692V1.82c0-.495-.445-.89-.94-.89z" />
      </g>
    </svg>
  </SvgContainer>
);
DentistChairPersonSvg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  margin: PropTypes.string,
  width: PropTypes.string,
};

export default DentistChairPersonSvg;
